import { DeliveryModel, Journey } from '@audibene/ta.utils-opportunity'
import { NonDeprecatedSolution } from '../../constants'

const salesforceJourneyToDomainJourney = {
  DIRECT_TO_CONSUMER_STANDARD: Journey.DIRECT_TO_CONSUMER_STANDARD,

  NETWORK_BEST_CHOICE: Journey.NETWORK_BEST_CHOICE,
  NETWORK_HEAR_TODAY: Journey.NETWORK_HEAR_TODAY,
  NETWORK_MEDICARE_ADVANTAGE: Journey.NETWORK_MEDICARE_ADVANTAGE,
  NETWORK_OVER_THE_COUNTER: Journey.NETWORK_STANDARD,
  NETWORK_STANDARD: Journey.NETWORK_STANDARD,
  NETWORK_TRUHEARING: Journey.NETWORK_STANDARD, // PX-1493
  NETWORK_YOUNG_HEARING_AID: Journey.NETWORK_YOUNG_HEARING_AID,

  NETWORK_HOME_DELIVERY_BEST_CHOICE: Journey.NETWORK_HOME_DELIVERY_BEST_CHOICE,
  NETWORK_HOME_DELIVERY_HEAR_TODAY: Journey.NETWORK_HOME_DELIVERY_HEAR_TODAY,
  NETWORK_HOME_DELIVERY_MEDICARE_ADVANTAGE: Journey.NETWORK_HOME_DELIVERY_MEDICARE_ADVANTAGE,
  NETWORK_HOME_DELIVERY_STANDARD: Journey.NETWORK_HOME_DELIVERY_STANDARD,
  NETWORK_HOME_DELIVERY_YOUNG_HEARING_AID: Journey.NETWORK_HOME_DELIVERY_YOUNG_HEARING_AID,
  NETWORK_HOME_DELIVERY_TRUHEARING: Journey.NETWORK_HOME_DELIVERY_STANDARD, // PX-1493

  // PX-2757
  TA_LIGHT_BEST_CHOICE: Journey.TA_LIGHT_BEST_CHOICE,
  TA_LIGHT_ECONOMY: Journey.TA_LIGHT_ECONOMY,
  TA_LIGHT_HEAR_TODAY: Journey.TA_LIGHT_HEAR_TODAY,
  TA_LIGHT_MEDICARE_ADVANTAGE: Journey.TA_LIGHT_MEDICARE_ADVANTAGE,
  TA_LIGHT_OVER_THE_COUNTER: Journey.TA_LIGHT_OVER_THE_COUNTER,
  TA_LIGHT_STANDARD: Journey.TA_LIGHT_STANDARD,
  TA_LIGHT_TRUHEARING: Journey.TA_LIGHT_TRUHEARING,

  TA_ONSITE_BEST_CHOICE: Journey.TA_ONSITE_BEST_CHOICE,
  TA_ONSITE_ECONOMY: Journey.TA_ONSITE_ECONOMY,
  TA_ONSITE_HEAR_TODAY: Journey.TA_ONSITE_HEAR_TODAY,
  TA_ONSITE_MEDICARE_ADVANTAGE: Journey.TA_ONSITE_MEDICARE_ADVANTAGE,
  TA_ONSITE_OVER_THE_COUNTER: Journey.TA_ONSITE_OVER_THE_COUNTER,
  TA_ONSITE_STANDARD: Journey.TA_ONSITE_STANDARD,
  TA_ONSITE_TRUHEARING: Journey.TA_ONSITE_TRUHEARING,

  TELEAUDIOLOGY_BEST_CHOICE: Journey.TELEAUDIOLOGY_BEST_CHOICE,
  TELEAUDIOLOGY_ECONOMY: Journey.TELEAUDIOLOGY_ECONOMY,
  TELEAUDIOLOGY_HEAR_TODAY: Journey.TELEAUDIOLOGY_HEAR_TODAY,
  TELEAUDIOLOGY_MEDICARE_ADVANTAGE: Journey.TELEAUDIOLOGY_MEDICARE_ADVANTAGE,
  TELEAUDIOLOGY_OVER_THE_COUNTER: Journey.TELEAUDIOLOGY_STANDARD,
  TELEAUDIOLOGY_RETAIL: Journey.TELEAUDIOLOGY_RETAIL,
  TELEAUDIOLOGY_STANDARD: Journey.TELEAUDIOLOGY_STANDARD,
  TELEAUDIOLOGY_TRUHEARING: Journey.TELEAUDIOLOGY_TRUHEARING, // PX-1493
} as const

const getJourneyFromDeliveryModelAndSolution = (deliveryModel: DeliveryModel, solution: NonDeprecatedSolution) => {
  const journeyString = `${deliveryModel}_${solution}`.toUpperCase()

  const journey = salesforceJourneyToDomainJourney[journeyString as keyof typeof salesforceJourneyToDomainJourney]

  if (!journey) {
    throw new Error(`Invalid combination of delivery model and solution: ${journeyString}`)
  }

  return journey
}

export { getJourneyFromDeliveryModelAndSolution }
